import React, { FC, useEffect, useState } from "react";
import { Icon } from "../Icon/Icon";
import {
  WrapperInput,
  StyledInput,
  StyledLabel,
  ErrorMessage,
  StyledIconWrapper,
  FieldWrapper,
} from "./InputWithValidation.style";
import styled from "styled-components";

const StyledButtonClear = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 78px;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 9px;

  @media (min-width: 768px) {
    right: 30px;
  }
`;

export const IconWrapper = styled.div<{ position: "start" | "end" }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0;
  position: absolute;
  margin: auto 0;
  bottom: 14px;
  right: 10px;
  z-index: 14;
`;

interface IInputProps {
  name: string;
  label?: string;
  placeholder?: string;
  iconSize?: number;
  value?: string | number;
  error: string | undefined;
  isDisabled?: boolean;
  isRequired?: boolean;
  isShadow?: boolean;
  isSearch?: boolean;
  icon?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onChange?: (arg: string) => void;
  iconEnd?: any;
}

export const InputWithValidation: FC<IInputProps> = (props): JSX.Element => {
  const {
    name = "",
    label = "",
    placeholder = "",
    iconSize = 16,
    error = "",
    value = "",
    isDisabled = false,
    isRequired = false,
    isShadow = false,
    isSearch = false,
    icon = "",
    onChange,
    onBlur,
    onFocus,
    iconEnd,
  } = props;

  const [isFocus, setIsFocus] = useState(false);
  const [inputValue, setInputValue] = useState<any>(value);

  useEffect(() => setInputValue(value), [value]);

  const handleBlur = () => {
    setIsFocus(false);
    if (onBlur) onBlur();
  };

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const inputValue: string = event.currentTarget.value;
    setInputValue(() => inputValue);

    if (!onChange) return;
    onChange(inputValue);
  };

  const handlerClear = () => {
    setInputValue(() => "");
    if (onChange) onChange("");
  };

  return (
    <WrapperInput>
      {label && <StyledLabel isRequired={isRequired}>{label}</StyledLabel>}
      <FieldWrapper>
        {(isSearch || icon) && (
          <StyledIconWrapper isSearch={isSearch}>
            <Icon name={icon} size={iconSize} color="gray-300" />
          </StyledIconWrapper>
        )}{" "}
        <StyledInput
          name={name}
          isError={!!error}
          isSearch={isSearch}
          isShadow={isShadow}
          icon={icon}
          value={inputValue}
          placeholder={placeholder}
          onChange={(event) => handleChange(event)}
          onBlur={handleBlur}
          onFocus={() => {
            setIsFocus(!isFocus);
            onFocus && onFocus();
          }}
          disabled={isDisabled}
        />
        {inputValue && isSearch && (
          <StyledButtonClear type="button" onClick={handlerClear}>
            <Icon name="cross" size={10} color="primary" />
          </StyledButtonClear>
        )}
      </FieldWrapper>
      {error && <ErrorMessage>{error}</ErrorMessage>}
      {iconEnd ? <IconWrapper position="end">{iconEnd}</IconWrapper> : null}
    </WrapperInput>
  );
};
